import { AppstoreAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import LeadActivityCreateMenu from 'automations/components/Nodes/LeadActivityCreateMenu';
import { type LeadActivityCreateNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useLeadActivityCreate(node: NodeProps<LeadActivityCreateNodeType>): TriggerNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.LeadActivityCreateNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <LeadActivityCreateMenu node={node} />, [node]);

  return {
    icon: AppstoreAddOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
